import localStorage from "./localStorage";
import router from "../router";

export default {
  setCompany(company) {
    return localStorage.set("company", company);
  },

  getCompany() {
    const company = localStorage.get("company");
    return company
      ? company
      : this.getUser()
      ? { ...this.getUser().employee.company }
      : {};
  },

  setToken(token) {
    return localStorage.set("user_token", token);
  },

  getToken() {
    return localStorage.get("user_token");
  },

  get() {
    return localStorage.get("user");
  },

  getUser() {
    return localStorage.get("user");
  },

  set(user) {
    return localStorage.set("user", user);
  },

  getEmployee() {
    return { ...this.getUser().employee };
  },

  getBranch() {
    return this.getUser() ? { ...this.getUser().employee.branch } : {};
  },

  getManagingBranches() {
    return this.getUser() ? [...this.getUser().managingBranches] : [];
  },

  managesMultipleBranch() {
    return this.getManagingBranches().length > 1;
  },

  getSubscription() {
    return [...this.getUser().packageModules];
  },

  getRoles() {
    return [...this.getUser().roles];
  },

  getPermissions() {
    const user = this.getUser();

    if (!user || user === undefined) {
      return false;
    }

    return [...this.getUser().permissions];
  },

  getPicture() {
    const picture = this.getUser().employee.picture;
    return picture !== null && picture !== ""
      ? picture
      : "/img/no-profile-pic.jpg";
  },

  getFullName() {
    const employee = this.getEmployee();

    return `${employee.first_name} ${employee.last_name}`;
  },

  isBranchHq() {
    return !!this.getBranch().is_hq;
  },

  isAdmin() {
    return this.can("view backend");
  },

  isHqAdmin() {
    return this.isAdmin() && this.isBranchHq();
  },

  isCompanyOwner() {
    return this.getEmployee().id === this.getCompany().head_station_id;
  },

  isCompanySuperAdmin() {
    return this.isAdmin() && this.isCompanyOwner();
  },

  can(permissionToCheck) {
    const permissions = this.getPermissions();

    if (!permissions || permissions === undefined) {
      return false;
    }

    const hasPermission = permissions.some(
      permission => permission === permissionToCheck
    );

    return hasPermission;
  },

  hasAnyPermission(permissionsToCheck) {
    if (permissionsToCheck === undefined || permissionsToCheck === null) {
      return false;
    }

    const hasAnyPermission = this.getPermissions().some(permission =>
      permissionsToCheck.some(permissionToCheck => {
        return permissionToCheck === permission;
      })
    );

    return hasAnyPermission;
  },

  hasAllPermissions(permissionsToCheck) {
    const seenPermissions = this.getPermissions().filter(permission =>
      permissionsToCheck.some(
        permissionToCheck => permissionToCheck === permission
      )
    );

    const hasAllPermissions =
      seenPermissions.length === permissionsToCheck.length;

    return hasAllPermissions;
  },

  getActiveView() {
    return localStorage.get("activeView");
  },

  setActiveView(activeView) {
    return localStorage.set("activeView", activeView);
  },

  getActiveBranch() {
    const activeBranch = localStorage.get("activeBranch");

    if (activeBranch && activeBranch !== undefined && activeBranch !== null) {
      return activeBranch;
    }

    if (this.getManagingBranches().length <= 0) {
      return false;
    }

    const firstBranch = "all";
    this.setActiveBranch(firstBranch);

    return firstBranch;
  },

  setActiveBranch(activeBranch) {
    return localStorage.set("activeBranch", activeBranch);
  },

  isAuthenticated() {
    const token = this.getToken();

    return token && token !== undefined && token !== null;
  },

  clearToken() {
    localStorage.clear("user_token");
  },

  clearStorage() {
    //TODO: still more work on logout here
    localStorage.clear("user_token");
    localStorage.clear("user");
    localStorage.clear("company");
    localStorage.clear("activeBranch");
  },

  logout() {
    this.clearToken();
    localStorage.clear("user");
    router.push({ name: "login" });
  },
  signInAsNewUser() {
    this.clearToken();
    localStorage.clear("user");
    router.push("/company");
  },
};
